<div>
  <p>{{ 'profile.account-deleted' | translate }}</p>
</div>
